import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';

import dayjs from 'dayjs';
import objectSupport from 'dayjs/plugin/objectSupport';

import {
    Progress,
    GoBackButton,
    LineChartCard,
    LineChartSMACard,
    PieChartCard,
} from '../../components/index';

import {
    InfoCard,
    PatientsEmotional,
    SessionNotesCard,
    TranscribeCard,
} from '../../components/Provider/Report';

import { GET_MEET_REPORT, getReport } from '../../services/provider';
import { transcribe } from '../../services';

import { alertError } from '../../redux/stateActions';
import { providerPageWidth } from '../../constant';

dayjs.extend(objectSupport);

const Report = ({ history, location }) => {
    const dispatch = useDispatch();
    const { id } = useParams();

    const [loading, setLoading] = useState(false);
    const [realTime, setRealTime] = useState([]);
    const [expressionByPatient, setExpressionByPatient] = useState([]);
    const [meetData, setMeetData] = useState({});

    const [reportData, setReportData] = useState([]);
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [selectedSummary, setSelectedSummary] = useState([]);
    const [selectedSessionNotes, setSelectedSessionNotes] = useState([]);

    const [transcribes, setTranscribes] = useState([]);

    const defualtExpression = [
        {
            fullMark: 100,
            name: 'neutral',
            value: 0,
        },
        {
            fullMark: 100,
            name: 'happy',
            value: 0,
        },
        {
            fullMark: 100,
            name: 'sad',
            value: 0,
        },
        {
            fullMark: 100,
            name: 'angry',
            value: 0,
        },
        {
            fullMark: 100,
            name: 'fearful',
            value: 0,
        },
        {
            fullMark: 100,
            name: 'disgusted',
            value: 0,
        },
        {
            fullMark: 100,
            name: 'surprised',
            value: 0,
        },
    ];

    const handleGoBack = () => {
        if (location.state?.prevPath) {
            const path = {
                pathname: location.state.prevPath,
                state: {
                    tab: location.state.prevTab,
                },
            };
            history.push(path);
        } else {
            history.goBack();
        }
    };

    const fetchReport = async () => {
        setLoading(true);
        try {
            const res = await getReport(id);

            if (res.status === 200) {
                const newExpressionByPatient = [];
                const newReportData = [];
                console.log('res.datares.data',res.data);
                if (res.data.length === 0) {
                    setSelectedPatient(meetData.patients[0].id);
                }
                meetData.patients.forEach((eleMeet, index) => {
                    const patientID = eleMeet.id;
                    const item = res.data.find((ele) => ele.patientID === patientID);
                    if (index === 0) {
                        setSelectedPatient(patientID);
                    }
                    if (item) {
                        const reportObj = {
                            patientID: item.patientID,
                            summary: item.summary,
                            realTime: item.realTime,
                        };

                        newReportData.push(reportObj);
                    }

                    const expressionObj = {
                        expression: item?.byExpression || defualtExpression,
                        patient: meetData.patients.find((patient) => patient.id === patientID),
                    };
                    newExpressionByPatient.push(expressionObj);
                });

                setReportData(newReportData);
                setExpressionByPatient(newExpressionByPatient);
            } else {
                throw new Error(res);
            }
        } catch (error) {
            dispatch(alertError('Cannot Get report ' + error.message));
        }
        setLoading(false);
    };

    useEffect(() => {
        if (selectedPatient && !_.isEmpty(reportData) && !_.isEmpty(meetData)) {
            const foundReport = reportData.find((r) => r.patientID === selectedPatient);
            if (foundReport) {
                setSelectedSummary(foundReport.summary);
                setRealTime(foundReport.realTime);
            } else {
                setSelectedSummary([]);
                setRealTime([]);
                // dispatch(alertError('Report of this selected client not found'));
            }
        }
        if (selectedPatient && !_.isEmpty(meetData)) {
            
            const foundSession = meetData.sessions.find(
                (s) => {
                    const find = s.patient_summaries.find((e) => e.patient.id  ===  selectedPatient)
                    if (find) {
                        return s
                    }
                }
            
            );
            console.log('foundSession',foundSession);
            if (foundSession) {
                setSelectedSessionNotes(foundSession.session_notes);
            } else {
                setSelectedSessionNotes([]);
                // dispatch(alertError('Session notes of this selected client not found'));
            }
        }
    }, [selectedPatient, reportData, meetData]);

    useEffect(() => {
        if (id && !_.isEmpty(meetData)) {
            fetchReport();
        }
    }, [id, meetData]);

    /*--------------- Get Meet ---------------*/
    const { data: getMeetData, error: getMeetError } = useQuery(GET_MEET_REPORT, {
        variables: { id: id },
        skip: !id,
    });

    useEffect(() => {
        if (getMeetError) {
            dispatch(alertError(`Cannot get Meet data: ${getMeetError.message}`));
        }

        if (getMeetData && _.isEmpty(getMeetData.meet)) {
            dispatch(alertError(`Meet not found`));
        }

        if (getMeetData && !_.isEmpty(getMeetData.meet)) {
            setMeetData(getMeetData.meet);

            const users = [];
            const arrRoom = [];
            users.push(getMeetData.meet.staff.user);

            if (getMeetData.meet.sessions.length === 0) return;
            getMeetData.meet.sessions.forEach((session) => {
                arrRoom.push({
                    roomId: session.roomId,
                    patientId: session.patient_summaries[0].patient.id,
                });

                if (session.patient_summaries[0].patient?.user) {
                    users.push(session.patient_summaries[0].patient?.user);
                }
            });

            getTranscribes(arrRoom, users);
        }
    }, [getMeetError, getMeetData]);

    const getTranscribes = async (arrRoom, users) => {
        const transcribesPromise = arrRoom.map(async (room) => {
            const res = await transcribe(room.roomId);

            return { ...res, patientId: room.patientId };
        });

        const transcribesPromiseRes = await Promise.all(transcribesPromise);

        console.log('transcribesPromiseRes', transcribesPromiseRes);

        const newTransaction = [];
        transcribesPromiseRes.forEach((item) => {
            if (!item) return;

            const obj = {
                patientId: item.patientId,
                status: item.status,
                record: [],
            };
            item?.recordTranslate?.forEach((record) => {
                const lastItem = _.last(obj.record);

                if (lastItem && lastItem?.user?.id === record.userId) {
                    obj.record[obj.record.length - 1].texts.push(record.text);
                } else {
                    obj.record.push({
                        startAt: dayjs(record.startAt).format('HH:mm'),
                        texts: [record.text],
                        user: users.find((user) => user.id === record.userId),
                    });
                }
            });
            newTransaction.push(obj);
        });

        setTranscribes(newTransaction);
    };

    useEffect(() => {
        console.log('transcribes', transcribes);
    }, [transcribes]);

    return (
        <div
            style={{
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                rowGap: '25px',
                maxWidth: providerPageWidth,
                width: '100%',
            }}
        >
            {loading && <Progress />}

            <GoBackButton $text onClick={handleGoBack} />

            <InfoCard meet={meetData} />

            <PatientsEmotional
                data={expressionByPatient}
                selectedPatient={selectedPatient}
                setSelectedPatient={setSelectedPatient}
            />

            <LineChartCard data={realTime} />

            <LineChartSMACard data={realTime} />

            <PieChartCard data={selectedSummary} />

            <SessionNotesCard data={selectedSessionNotes} />

            <TranscribeCard
                data={transcribes.find((item) => item?.patientId === selectedPatient)}
            />
        </div>
    );
};

Report.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
};

export default Report;
